import { QueryClient } from '@tanstack/react-query'

// A standalone module (not created inside main.tsx) so non-React code — the sign-out helper,
// the axios interceptor — can clear the cache too, the same way window.Clerk lets them reach
// Clerk outside the component tree.
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
})
